import Vue from "vue";
import Vuex from "vuex";
import axios from 'axios';
import api from "./constants/api";
import io from "socket.io-client";

Vue.use(Vuex);

// Guard against a corrupt/"undefined" localStorage value white-screening the
// whole app at boot (JSON.parse would throw). Mirrors the helper in
// snap-drive-admin-dashboard/src/store.js.
function parseStoredJson(key, fallback) {
    const rawValue = localStorage.getItem(key);

    if (rawValue === null || rawValue === "" || rawValue === "undefined" || rawValue === "null") {
        return fallback;
    }

    try {
        return JSON.parse(rawValue);
    } catch (_error) {
        localStorage.removeItem(key);
        return fallback;
    }
}

export default new Vuex.Store({
    state: {
        user: parseStoredJson('user', null),
        notifications: parseStoredJson('notifications', []),
        socket: null,
        userCancellationReason: [],
        ai_status: {
            snoozed_at: null,
            snooze_interval: 0,
            dispatch_interval: 0,
            ai_stopped: '0'
        },
    },
    getters: {
        getUserCancellationReason(state) {
            return state.userCancellationReason;
        }
    },
    mutations: {
        setUserCancellationReason(state, value) {
            state.userCancellationReason = value;
        },
        SET_AI_STATUS(state, status) {
            state.ai_status = status;
        },
        USER_NAME(state, USER_NAME) {
            state.USER_NAME = USER_NAME;
        },
        LOGIN(state, user) {
            state.user = user;
            axios.defaults.headers.common['Authorization'] = `Bearer ${user.accessToken}`;
            localStorage.setItem('user', JSON.stringify(user));
        },
        LOGOUT(state) {
            try {
                axios.defaults.headers.common['Authorization'] = ``;
                state.user = null;
                localStorage.removeItem('user');
                localStorage.removeItem('notifications');
                if (state.socket) state.socket.disconnect();
            } catch (e) {
                console.log(e);
            }
        },
        NEW_NOTIFICATION(state, notification) {
            state.notifications = [...state.notifications, notification];
            localStorage.setItem('notifications', JSON.stringify(state.notifications));
        },
        INIT_SOCKET(state) {
            state.socket = io(api.SOCKET.USERS, {
                transportOptions: {
                    polling: {
                        extraHeaders: axios.defaults.headers.common
                    }
                }
            });

            state.socket.on('connect', () => {
                console.log("connected");
            });

            state.socket.on(api.SOCKET.EVENTS.NEW_NOTIFICATION, ({ message, datetime = +new Date(), color = 'orange' }) => this.commit('NEW_NOTIFICATION', {
                message,
                color,
                datetime
            }));
            state.socket.on('Ai:status_updated', ai_status => this.commit('SET_AI_STATUS', ai_status));
        }
    },
    actions: {
        async validateToken({ commit, state }, token = null) {
            try {
                let baseUser;
                if (!token) {
                    baseUser = state.user;
                    token = baseUser.accessToken;
                } else {
                    baseUser = {
                        accessToken: token
                    };
                }

                axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
                const { data: { data: user } } = await axios.get(api.ACTIONS.CHECK_TOKEN);
                await commit('LOGIN', Object.assign({}, baseUser, user));
                await commit('SET_AI_STATUS', user.ai_status);
            } catch (e) {
                commit('LOGOUT');
            }
        },
        async initSocket({ commit, state }) {
            if (state.socket) state.socket.disconnect();
            commit('INIT_SOCKET');
        },
        getUserCancellationReasons({ commit, state }) {
            if (state.userCancellationReason.length > 0) {
                return state.userCancellationReason;
            }
            return new Promise((resolve, reject) => {
                axios.get(api.ACTIONS.USER_CANCELLATION_REASONS, {
                    params: {
                        only_visible_to_user: true,
                        perPage: 100,
                        page: 1
                    }
                })
                    .then(res => {
                        const responseData = res.data.data;
                        const data = (responseData && responseData.data) || responseData || [];
                        commit('setUserCancellationReason', data);
                        resolve(data);
                    })
                    .catch(err => {
                        if (err.message == "Network Error" && !err.response) {
                            reject("Please check your Internet connection");
                        } else {
                            reject(err.response && err.response.data && err.response.data.message || err.message);
                        }
                    });
            });
        }
    }
});
